import { createContext } from 'react';
import { useState } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import {Routes, Route} from "react-router-dom"
import Hero from './components/Hero';
import Quiz from './components/pages/Quiz';
import Footer from './components/Footer';


export const appContext = createContext();

function App() {
  const [navToggle, setNavToggle] = useState(false);




  return (
    <appContext.Provider value={{navToggle, setNavToggle}}>
  
      <Navbar />
      <Routes>

        <Route path='/' element={<Hero />}></Route>
        <Route path='/quiz/:id' element={<Quiz />}></Route>


      </Routes>

      <Footer/>

      

    </appContext.Provider>
  );
}

export default App;
